import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/warning.svg
 */
const IconWarning: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M10.5 7.499a1.5 1.5 0 012.998 0v4.499a1.5 1.5 0 11-2.999 0v-4.5zm1.5 7.5a1.502 1.502 0 011.06 2.561 1.5 1.5 0 01-2.56-1.06 1.417 1.417 0 011.5-1.501z"
      fill="currentColor"
    />
    <path
      d="M12 0A12 12 0 110 11.998 12.033 12.033 0 0112 0zm0 22.515A10.517 10.517 0 101.483 11.998 10.546 10.546 0 0012 22.515z"
      fill="currentColor"
    />
  </svg>
);

export default IconWarning;
